/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const LiteLLMGuardrailAction = {
  Blocked: "BLOCKED",
  None: "NONE",
  GuardrailIntervened: "GUARDRAIL_INTERVENED",
} as const;
export type LiteLLMGuardrailAction = OpenEnum<typeof LiteLLMGuardrailAction>;

/**
 * LiteLLM Generic Guardrail decision.
 */
export type LitellmIngestResult = {
  liteLLMGuardrailAction: LiteLLMGuardrailAction;
  blockedReason?: string | undefined;
  images?: Array<string> | undefined;
  streamHoldbackChars?: Array<number> | undefined;
  texts?: Array<string> | undefined;
  tools?: Array<any> | undefined;
};

/** @internal */
export const LiteLLMGuardrailAction$inboundSchema: z.ZodMiniType<
  LiteLLMGuardrailAction,
  unknown
> = openEnums.inboundSchema(LiteLLMGuardrailAction);

/** @internal */
export const LitellmIngestResult$inboundSchema: z.ZodMiniType<
  LitellmIngestResult,
  unknown
> = z.pipe(
  z.object({
    action: LiteLLMGuardrailAction$inboundSchema,
    blocked_reason: z.optional(z.string()),
    images: z.optional(z.array(z.string())),
    stream_holdback_chars: z.optional(z.array(z.int())),
    texts: z.optional(z.array(z.string())),
    tools: z.optional(z.array(z.any())),
  }),
  z.transform((v) => {
    return remap$(v, {
      "action": "liteLLMGuardrailAction",
      "blocked_reason": "blockedReason",
      "stream_holdback_chars": "streamHoldbackChars",
    });
  }),
);

export function litellmIngestResultFromJSON(
  jsonString: string,
): SafeParseResult<LitellmIngestResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => LitellmIngestResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'LitellmIngestResult' from JSON`,
  );
}
